import { createHashHistory }  from 'history';
// import {showExternalContent} from "../redux/external-content-config/external-content-config-actions";
// import {shouldShowTopBanner} from "../components/main/banner/banner-lib";
// import {eExternalContentComponents} from "../utils/enums";
import KambiRoutesConfig from '../services/kambi-client-sdk/kambi-routes-config';
import InternalLinkLib from '../components/shared/internal-link-lib';
import HtmlHelper from '../utils/html-helper';
import { mainContentId } from '../utils/constants';

export const routerHistory = (() => {

  let history = null;

  // function processRoute(store, location) {
  // const isMobileLook = store.getState().appUI.isMobileLook;
  // const hashValue = location.pathname.slice(1); // removed first "/" from location.pathname
  // const isTopBannerVisible = shouldShowTopBanner(hashValue, isMobileLook);
  // store.dispatch(showExternalContent(eExternalContentComponents.TOP_BANNER, isTopBannerVisible));
  // }


  return {
    getHistory: () => {
      return history;
    },

    createHashHistory: () => {
      if (!history)
        history = createHashHistory();
      return history;
    },
    //TODO[EV]: this should be removed as is not useful anymore
    //TODO[EV]: if this is removed a bug appears on home page: the redirect to /home is not done anymore
    //TODO[EV]: keep this here until the bug can be investigated and fied
    registerHistoryListener: (/*store*/) => {
      // processRoute(store, history.location);
      history.listen((/*location*/) => {
        // processRoute(store, location);
      });
    }
  };

})();

/**
 * This function returns a boolean that shows if the received route is an 888 route based on Kambi emptyClientRoutes
 *
 * @param locationHashValue - url hash value (ex: filter/politics, home - make sure to remove any prefix like "/" or "#/")
 * @returns {boolean}
 */
export const is888SpecificRoute = (locationHashValue) => {
  const sportClientRoutes = KambiRoutesConfig.getEmptyClientRoutes();
  const is888SpecificRoute = sportClientRoutes.some(emptyClientRoute => new RegExp(emptyClientRoute).exec(locationHashValue));
  return is888SpecificRoute;
};

export const redirectToDefaultPageIfNeeded = () => {
  const hashRouteFromMetaTag = HtmlHelper.getHashRouteFromMetaTag();
  const currentHash = window.location.hash.slice(2); //removed "#/" from the start of window.location.hash
  if (!currentHash && hashRouteFromMetaTag) {
    InternalLinkLib.goToInternalRoute(hashRouteFromMetaTag);
  }

  const sportClientContainer = document.getElementById(mainContentId);
  if (!currentHash && !hashRouteFromMetaTag && sportClientContainer) {
    InternalLinkLib.goToInternalRoute('home');
  }


};
